<template>
  <input
    type="text"
    :value="originalValue"
    @input="updateInput"
  >
</template>

<script>
export default {
  props: ['value'],

  data() {
    return {
      originalValue: '',
    }
  },

  watch: {
    'value': function (newValue, oldValue) {

      // The new value must contain the magic override text to avoid
      // circular logic, because this function is called when we change
      // the value from within due to the two way data-binding.
      const overrideText = '__OVERRIDE__';

      if (typeof newValue !== 'string') {
        return;
      }

      if (newValue.indexOf(overrideText) === 0) {
        this.originalValue = newValue.substr(overrideText.length);
        this.$emit('input', this.convert_fraction_to_decimal(this.originalValue));
      }
    },
  },

  mounted() {
    this.originalValue = this.value;
  },

  methods: {
    convert_fraction_to_decimal(value) {
      value = value.toString();

      // regexr.com/5n1ju
      let fractionRegex = /^(\d*)\s*((\d+)\/(\d+))$/;

      if (fractionRegex.test(value)) {
        let result = value.match(fractionRegex);

        let whole = parseFloat(result[1] || 0);
        let numerator = parseFloat(result[3]);
        let denominator = parseFloat(result[4]);

        try {
          this.$el.setCustomValidity('');

          return (numerator / denominator + whole).toFixed(2);
        } catch (e) {
          // Handled below
        }
      }

      // Not-not a number (is a number)
      if (! isNaN(parseFloat(value))) {
        // https://stackoverflow.com/a/18883194
        this.$el.setCustomValidity('');

        return parseFloat(value).toFixed(2);
      }

      this.$el.setCustomValidity('Please enter a decimal or fraction of the format "A B/C".');

      return value;
    },

    updateInput(event) {
      this.$emit('input', this.convert_fraction_to_decimal(event.target.value));
    }
  }
}
</script>

<style scoped>

</style>
